import { AccountButton } from '@latticexyz/entrykit/internal'
import { createFileRoute, Link, Outlet } from '@tanstack/react-router'
import { useState } from 'react'
import { useRole } from '../context/role'
import { useIsAdmin } from '../hooks/use-is-admin'
import { DownloadAppButton } from '../ui/download-app-button'

const AppLayout = () => {
  const { config } = useRole()
  const isAdmin = useIsAdmin()
  const [mobileOpen, setMobileOpen] = useState(false)

  const navLinks = [
    { to: '/' as const, label: 'Batches', show: true },
    { to: '/batch/create' as const, label: 'Create Batch', show: config.canCreate },
    { to: '/tag/provision' as const, label: 'Provision NFC Tag', show: isAdmin },
  ].filter((l) => l.show)

  return (
    <>
      <div className="sticky top-0 z-40 border-b border-warm-200 bg-white">
        <div className="px-4 sm:px-6 py-3 flex items-center gap-3 sm:gap-6">
          <span className="font-display text-lg sm:text-xl font-bold text-warm-900 tracking-tight">
            Logistics DPP
          </span>
          <nav className="hidden sm:flex items-center gap-5 ml-1">
            {navLinks.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                className="text-sm font-medium text-warm-500 hover:text-warm-900 [&.active]:text-terra-600 [&.active]:font-semibold"
              >
                {l.label}
              </Link>
            ))}
          </nav>

          <div className="ml-auto flex items-center gap-2 sm:gap-3">
            <DownloadAppButton />
            <AccountButton />
            <button
              className="sm:hidden p-1.5 rounded-lg text-warm-600 hover:bg-warm-50 transition-colors"
              onClick={() => setMobileOpen((o) => !o)}
              aria-label="Toggle menu"
            >
              {mobileOpen ? (
                <svg className="w-5 h-5" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
              ) : (
                <svg className="w-5 h-5" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clipRule="evenodd" />
                </svg>
              )}
            </button>
          </div>
        </div>

        {mobileOpen && (
          <nav className="sm:hidden border-t border-warm-100 bg-white px-4 py-1.5 flex flex-col">
            {navLinks.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                onClick={() => setMobileOpen(false)}
                className="py-2.5 text-sm font-medium text-warm-700 border-b border-warm-50 last:border-0 [&.active]:text-terra-600"
              >
                {l.label}
              </Link>
            ))}
          </nav>
        )}
      </div>
      <Outlet />
    </>
  )
}

export const Route = createFileRoute('/_app')({ component: AppLayout })
